import { jsx, jsxs } from "react/jsx-runtime";
function InfoIcon() {
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 64 64",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M32 58.6666C39.3637 58.6666 46.0304 55.6818 50.8561 50.8561C55.6819 46.0303 58.6667 39.3637 58.6667 31.9999C58.6667 24.6362 55.6819 17.9695 50.8561 13.1437C46.0304 8.31802 39.3637 5.33325 32 5.33325C24.6363 5.33325 17.9696 8.31802 13.1438 13.1437C8.31812 17.9695 5.33334 24.6362 5.33334 31.9999C5.33334 39.3637 8.31812 46.0303 13.1438 50.8561C17.9696 55.6818 24.6363 58.6666 32 58.6666Z",
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: "5.33333",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.1667 18.6667C33.6394 18.6667 34.8333 19.8607 34.8333 21.3334C34.8333 22.8062 33.6394 24.0001 32.1667 24.0001C30.6939 24.0001 29.5 22.8062 29.5 21.3334C29.5 19.8607 30.6939 18.6667 32.1667 18.6667Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M32.6667 40.7313V27.6086H31.7102H30.7536",
                stroke: "white",
                strokeWidth: "4.26667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M29.3189 41H36.0146",
                stroke: "white",
                strokeWidth: "3.82612",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
export { InfoIcon as default };
